import { APPEARANCE_THEMES, normalizeAppearanceTheme } from '@/theme/theme-config';

export const APPEARANCE_THEME_CACHE_KEY = 'dms.appearance-theme';

export const readCachedAppearanceTheme = () => {
  try {
    const cachedTheme = window.localStorage.getItem(APPEARANCE_THEME_CACHE_KEY);

    return cachedTheme === APPEARANCE_THEMES.LIGHT || cachedTheme === APPEARANCE_THEMES.DARK
      ? cachedTheme
      : null;
  } catch {
    return null;
  }
};

export const cacheAppearanceTheme = (appearanceTheme) => {
  try {
    window.localStorage.setItem(
      APPEARANCE_THEME_CACHE_KEY,
      normalizeAppearanceTheme(appearanceTheme)
    );
  } catch {
    // The server-persisted preference remains authoritative when storage is unavailable.
  }
};
